import { AxiosResponse } from 'axios';
import { Request } from '../../../api';

export interface MergePreviewData {
    uuid: string;
    name: string;
    created_at: string | null;
    profile_photo: string | null;
    organization: {
        uuid: string;
        name: string;
    } | null;
    managing_user: {
        uuid: string;
        name: string;
        user_name: string | null;
        email: string;
        phone: string | null;
    } | null;
    groups: Array<{
        uuid: string;
        name: string;
    }>;
    external_ids: Array<{
        type: string;
        value: string;
    }>;
    uploads: {
        total: number;
        by_month: Record<string, number>;
    };
}

export interface MergePreviewResponse {
    data: MergePreviewData;
}

export function getMergePreview(
    individualId: string,
): Promise<AxiosResponse<MergePreviewResponse>> {
    return Request.get(`/individuals/${individualId}/merge-preview`);
}
